import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Auth, signOut } from '@angular/fire/auth';
import { TuiIcon, TuiTitle } from '@taiga-ui/core';
import { ProjectStore, TaigaSize, ApplicationStore } from '@ffx/app-store';
import { Router } from '@angular/router';

@Component({
    selector: 'ffx-logout',
    standalone: true,
    imports: [CommonModule, TuiIcon, TuiTitle],
    templateUrl: './logout.component.html',
    styleUrl: './logout.component.scss'
})
export class LogoutComponent {
    @Input() size: TaigaSize = 'm';
    private projectStore = inject(ProjectStore);
    private appStore = inject(ApplicationStore);
    private router = inject(Router);

    constructor(private auth: Auth) {}
    async logout(): Promise<void> {
        this.appStore.clearStore();
        this.projectStore.clearStore();

        try {
            await signOut(this.auth);
        } catch (error) {
            console.log(error);
        }

        this.router.navigate(['/login']);
    }
}
